import React, { HTMLAttributeAnchorTarget } from 'react';

import NextLink from 'next/link';
import { twMerge } from 'tailwind-merge';

import { LinkType } from '@core/types';

type Props = {
  className?: string;
  link: string;
  title: string;
  target?: HTMLAttributeAnchorTarget;
  type?: LinkType;
};

const Link = ({
  link,
  title,
  className,
  target = '_blank',
  type = 'link'
}: Props) => {
  const classes = twMerge(
    'font-medium hover:underline text-grey text-sm',
    className
  );

  const linkIncludingPrefix = () => {
    switch (type) {
      case 'email':
        return `mailto:${link}`;
      case 'phone':
        return `tel:${link}`;
      default:
        return link;
    }
  };

  return (
    <NextLink target={target} className={classes} href={linkIncludingPrefix()}>
      {title}
    </NextLink>
  );
};

export default Link;
